import { IconButton, Stack, ButtonGroup, Tooltip, StackProps } from "@mui/material";
import { OpenInFullOutlined, ZoomIn, ZoomOut, CloseFullscreenOutlined } from "@mui/icons-material";

type MediaViewerToolProps = StackProps & {
  onZoomIn?: () => void;
  onZoomOut?: () => void;
  onFullScreen?: () => void;
  exitFullScreen?: () => void;
  hideZoomControls?: boolean;
  hideFullScreenControl?: boolean;
};
export default function MediaViewerTool({
  onZoomOut,
  onZoomIn,
  onFullScreen,
  exitFullScreen,
  hideZoomControls = false,
  hideFullScreenControl = false,
  className = "",
  sx = {},
  ...restProps
}: MediaViewerToolProps) {
  return (
    <Stack
      className={`control-btn-wrapper ${className}`?.trim()}
      sx={{ position: "absolute", right: 20, bottom: 20, transition: "300ms linear", ...sx }}
      {...restProps}
    >
      <ButtonGroup
        sx={{
          background: "#FCFCFD80",
          border: "1px solid #FCFCFD99",
          backdropFilter: "blur(2px)",
          borderRadius: "1.9375rem",
          padding: "0.375rem 0.75rem",
          height: "2.5rem"
        }}
      >
        {!hideZoomControls && (
          <>
            <Tooltip title='Zoom out'>
              <IconButton aria-label='Zoom out' onClick={onZoomOut}>
                <ZoomOut sx={{ fontSize: "1.5rem" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title='Zoom in'>
              <IconButton aria-label='Zoom in' onClick={onZoomIn}>
                <ZoomIn sx={{ fontSize: "1.5rem" }} />
              </IconButton>
            </Tooltip>
          </>
        )}

        {!hideFullScreenControl &&
          (!exitFullScreen ? (
            <Tooltip title='Full screen'>
              <IconButton aria-label='full screen' onClick={onFullScreen}>
                <OpenInFullOutlined sx={{ fontSize: "1.5rem" }} />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title='Exit full screen'>
              <IconButton aria-label='Exit full screen' onClick={exitFullScreen}>
                <CloseFullscreenOutlined sx={{ fontSize: "1.5rem" }} />
              </IconButton>
            </Tooltip>
          ))}
      </ButtonGroup>
    </Stack>
  );
}
